"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _isValidI18nKey = _interopRequireDefault(require("I18n/utils/isValidI18nKey"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router-dom/UIRouterLink"));

var _UIDescriptionList = _interopRequireDefault(require("UIComponents/list/UIDescriptionList"));

var _UITag = _interopRequireDefault(require("UIComponents/tag/UITag"));

var _FilterTag = _interopRequireDefault(require("../FilterTag"));

var Category = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/groupTags/Category"));

var _i18n = require("ecosystem-marketplace-core/utils/i18n");

var _offerings = require("ecosystem-marketplace-core/utils/offerings");

var _sentry = require("../../../../utils/sentry");

var _urls = require("../../../../utils/urls");

var _FilterKey = require("../../../../constants/search/FilterKey");

var I18N_PATH = 'appMarketplace.detail.overview.sidebar.details';

var InstallsBucket = function InstallsBucket(_ref) {
  var value = _ref.value;
  var bucket = (0, _offerings.getInstallsBucket)(value);

  if (!bucket) {
    return _react.default.createElement(_FormattedMessage.default, {
      message: I18N_PATH + ".installsBuckets.min"
    });
  }

  return _react.default.createElement(_FormattedJSXMessage.default, {
    message: I18N_PATH + ".installsBuckets.bucket_jsx",
    options: {
      value: bucket
    },
    elements: {
      Number: _FormattedNumber.default
    }
  });
};

var Section = function Section(_ref2) {
  var children = _ref2.children,
      label = _ref2.label,
      labelClassName = _ref2.labelClassName;
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement("dt", {
    className: labelClassName
  }, label), _react.default.createElement("dd", null, children));
};

var AppDetails = function AppDetails(_ref3) {
  var category = _ref3.category,
      companyName = _ref3.companyName,
      companyUrl = _ref3.companyUrl,
      categoryFeatures = _ref3.categoryFeatures,
      getFilterLink = _ref3.getFilterLink,
      installs = _ref3.installs,
      isPieSyncConnector = _ref3.isPieSyncConnector,
      isPreview = _ref3.isPreview,
      isUngatedForRemovePieSyncConnectorInstallCount = _ref3.isUngatedForRemovePieSyncConnectorInstallCount,
      onTrackInteraction = _ref3.onTrackInteraction;
  var trackInteraction = (0, _react.useCallback)(function (action, value) {
    return onTrackInteraction(action, 'details', value);
  }, [onTrackInteraction]);
  var renderedCategorySection = (0, _react.useMemo)(function () {
    return category ? _react.default.createElement(Section, {
      label: (0, _unescapedText.default)(I18N_PATH + ".categoryLabel"),
      labelClassName: "m-bottom-1"
    }, _react.default.createElement(_UIRouterLink.default, {
      disabled: isPreview,
      to: getFilterLink()
    }, _react.default.createElement(_FilterTag.default, null, _react.default.createElement(_UITag.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: (0, _i18n.getCategoryI18nKey)(category)
    }))))) : null;
  }, [category, getFilterLink, isPreview]);
  var renderedFeaturesSection = (0, _react.useMemo)(function () {
    return category && !categoryFeatures.isEmpty() ? _react.default.createElement(Section, {
      label: (0, _unescapedText.default)(I18N_PATH + ".featuresLabel"),
      labelClassName: "m-bottom-1"
    }, categoryFeatures.map(function (feature) {
      return [feature, (0, _i18n.getCategoryFeatureI18nKey)(category, feature)];
    }).filter(function (_ref4) {
      var _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
          feature = _ref5[0],
          featureI18nKey = _ref5[1];

      if (!(0, _isValidI18nKey.default)(featureI18nKey)) {
        (0, _sentry.reportMissingCategoryFeatureTranslation)(category, feature, {
          component: 'AppDetail'
        });
        return false;
      }

      return true;
    }).sortBy(function (_ref6) {
      var _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
          __ = _ref7[0],
          featureI18nKey = _ref7[1];

      return (0, _unescapedText.default)(featureI18nKey);
    }).map(function (_ref8) {
      var _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
          feature = _ref9[0],
          featureI18nKey = _ref9[1];

      return _react.default.createElement(_UIRouterLink.default, {
        key: feature,
        disabled: isPreview,
        to: getFilterLink(_FilterKey.CATEGORY_FEATURES, feature)
      }, _react.default.createElement(_FilterTag.default, null, _react.default.createElement(_UITag.default, {
        className: "m-left-0 m-right-1"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: featureI18nKey
      }))));
    })) : null;
  }, [category, categoryFeatures, getFilterLink, isPreview]);
  var renderedCompanyName = (0, _react.useMemo)(function () {
    return companyUrl ? _react.default.createElement(_UILink.default, {
      external: true,
      href: (0, _urls.getFormattedUrl)(companyUrl),
      onClick: function onClick() {
        return trackInteraction('click provider link');
      }
    }, companyName) : companyName;
  }, [companyName, companyUrl, trackInteraction]);
  var renderedInstallsSection = (0, _react.useMemo)(function () {
    if (isPieSyncConnector && isUngatedForRemovePieSyncConnectorInstallCount) {
      return null;
    }

    return _react.default.createElement(Section, {
      label: (0, _unescapedText.default)(I18N_PATH + ".installsLabel")
    }, _react.default.createElement(InstallsBucket, {
      value: installs
    }));
  }, [installs, isPieSyncConnector, isUngatedForRemovePieSyncConnectorInstallCount]);
  return _react.default.createElement(_UIDescriptionList.default, null, _react.default.createElement(Section, {
    label: (0, _unescapedText.default)(I18N_PATH + ".providerLabel")
  }, renderedCompanyName), renderedInstallsSection, renderedCategorySection, renderedFeaturesSection);
};

AppDetails.propTypes = {
  category: _propTypes.default.oneOf(Object.values(Category)),
  categoryFeatures: _reactImmutableProptypes.default.set.isRequired,
  companyName: _propTypes.default.string.isRequired,
  companyUrl: _propTypes.default.string,
  getFilterLink: _propTypes.default.func.isRequired,
  installs: _propTypes.default.number.isRequired,
  isPieSyncConnector: _propTypes.default.bool.isRequired,
  isPreview: _propTypes.default.bool.isRequired,
  isUngatedForRemovePieSyncConnectorInstallCount: _propTypes.default.bool.isRequired,
  onTrackInteraction: _propTypes.default.func.isRequired
};
var _default = AppDetails;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/detail/overview/sidebar/AppDetails.js
// module id = 821
// module chunks = 209 210 211 212